var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconLinkWhite = function SvgIconLinkWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.772 7.257 2.53 8.5A3.515 3.515 0 0 0 7.5 13.47l1.243-1.242m3.485-3.485L13.47 7.5A3.515 3.515 0 0 0 8.5 2.53L7.257 3.771M6.5 9.5l3-3",
    stroke: "#fff",
    strokeOpacity: 0.75,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgIconLinkWhite;